module.exports = __webpack_public_path__ + "d8f0ffe7c1237226cb62628c10890d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/header/shaffi11-medium.jpg
// module id = B7t3
// module chunks = 0